"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLoginErrorSnackbarVariant = exports.hasPasswordChangeRequiredError = exports.isPasswordChangeRequiredError = void 0;
const PASSWORD_CHANGE_REQUIRED_ERROR_KEYS = new Set(["defaultPasswordMustBeChanged", "needSetNewPassword"]);
const isPasswordChangeRequiredError = (key) => {
    return typeof key === "string" && PASSWORD_CHANGE_REQUIRED_ERROR_KEYS.has(key);
};
exports.isPasswordChangeRequiredError = isPasswordChangeRequiredError;
const hasPasswordChangeRequiredError = (errors = []) => {
    return errors.some(({ key }) => (0, exports.isPasswordChangeRequiredError)(key));
};
exports.hasPasswordChangeRequiredError = hasPasswordChangeRequiredError;
const getLoginErrorSnackbarVariant = (key) => {
    return (0, exports.isPasswordChangeRequiredError)(key) ? "warning" : "error";
};
exports.getLoginErrorSnackbarVariant = getLoginErrorSnackbarVariant;
//# sourceMappingURL=password-change-required.js.map